<template>
    <div class="row filter">
        <div class="tab col-md-12">
          <div class="filter-body">
            <div class="row">
              <div class="col-md-4 gray-bg">
                
                <span class="filter-span">Dispositivo</span>
                <synoptic-filter class="mb-4" :page="page" :select-devices="selectDevices" :selected-site-id="this.selectedSite" :reset="reset" type="filter"></synoptic-filter>
                
                <span class="filter-span">Parametro</span>
                <vue-select :id="page + '-parameters'" :key="page + '-parameters'" :reset="page != 'consumptions' ? reset: null" :locked="locked['parameters']" :attributes="fields.parametersAttributes" @changed="changed"></vue-select>
              </div>
              <div class="col-md-4 shadow">
                <span class="filter-span">{{ page != 'acquisitions' ? 'Frequenza aggregazione': 'Frequenza aggregazione (opzionale)' }}</span>
                <vue-select :id="page + '-aggregation-frequency'" :key="page + '-aggregation-frequency'" :reset="reset" :locked="locked['aggregationFrequency']" :attributes="fields.aggregationFrequencyAttributes" @changed="changed"></vue-select>
                
                <span class="filter-span mar-top-15">{{ aggregationModeLabel }}</span>
                <vue-select :id="page + '-aggregation-mode'" :key="page + '-aggregation-mode'" :reset="page != 'consumptions' ? reset: null" :locked="locked['aggregationMode']" :attributes="fields.aggregationModeAttributes" @changed="changed"></vue-select>
                
                <span class="filter-span mar-top-15">Da</span>
                <vue-datepicker :id="page + '-lowerbound'" :key="page + '-lowerbound'" :reset="reset" :locked="locked['lowerbound']" :attributes="fields.lowerboundAttributes" @changed="changed"></vue-datepicker>
                
                <span class="filter-span mar-top-15">A</span>
                <vue-datepicker :id="page + '-upperbound'" :key="page + '-upperbound'" :reset="reset" :locked="locked['upperbound']" :attributes="fields.upperboundAttributes" @changed="changed"></vue-datepicker>
              </div>
              <div class="col md-4">
                <div class="filter-buttons">
                  <a class="button action light filters-btn" href="" @click.prevent="resetForm">reset</a>
                  <a class="button action dark filters-btn" href="" @click.prevent="exportData">esporta</a>
                  <a class="button action primary filters-btn" href="" @click.prevent="getData">genera</a>
                  <a v-if="page == 'consumptions'" class="button action dark filters-btn mt-5" href="" @click.prevent="exportDataSite">esporta&nbsp;sito</a>
                </div>
              </div>
            </div>
          </div>
        </div>

        <overlay :enabled="loading"></overlay>
    </div>
</template>

<script>
  import moment from 'moment'
  import SynopticFilter from '@/layouts/Synoptic/Filter.vue';
  import notificator from '../../mixins/notificator';
  import { mapGetters } from 'vuex'

  import VueSelect from '@/components/Fields/Select.vue';
  import VueDatepicker from '@/components/Fields/Datepicker.vue';

  import Overlay from '@/components/Overlay.vue';

  export default {
    props: ['page', 'selectDevices', 'settings'],

    components: {SynopticFilter, VueSelect, VueDatepicker, Overlay},

    mixins: [notificator],

    data() {
      return {
        parameters: [],
        loading: false,
        reset: null,
        ready: false,
        locked: {
          parameters: true,
          aggregationFrequency: false,
          aggregationMode: false,
          lowerbound: false,
          upperbound: false,
        },

        fields: {
          parametersAttributes: {},
          aggregationFrequencyAttributes: {},
          aggregationModeAttributes: {},
          lowerboundAttributes: {},
          upperboundAttributes: {}
        },              
      }
    },

    created() {
      //Parameters
      this.fields.parametersAttributes = this.settings.parametersAttributes;
      this.fields.parametersAttributes['value']['value'] = this['selected' + this.keyword + 'Parameters'];
      
      //Aggregation frequency
      this.fields.aggregationFrequencyAttributes = this.settings.aggregationFrequencyAttributes;
      this.fields.aggregationFrequencyAttributes['value']['value'] = this['selected' + this.keyword + 'AggregationFrequency'];
      
      //Aggregation mode
      this.fields.aggregationModeAttributes = this.settings.aggregationModeAttributes;
      this.fields.aggregationModeAttributes['value']['value'] = this['selected' + this.keyword + 'AggregationMode'];
      
      //Lowerbound
      this.fields.lowerboundAttributes = this.settings.lowerboundAttributes;
      this.fields.lowerboundAttributes['value']['value'] = this['selected' + this.keyword + 'Lowerbound'];
      
      //Upperbound
      this.fields.upperboundAttributes = this.settings.upperboundAttributes;
      this.fields.upperboundAttributes['value']['value'] = this['selected' + this.keyword + 'Upperbound'];

      if((this['selected' + this.keyword + 'Devices'] && this.page == 'acquisitions' && this['selected' + this.keyword + 'Devices']['multidevice']) || (this['selected' + this.keyword + 'Devices'] != null && this['selected' + this.keyword + 'Devices']['device'] != null && this.keyword != 'Consumptions'))
        this.getClientDeviceParameters();
    },

    mounted() {
      this.ready = true;
    },

    computed: {    
      ...mapGetters([
        'token',
        'clientId',
        'clientSites',
        'selectedSite',

        'selectedAcquisitionsDevices',
        'selectedAcquisitionsParameters',
        'selectedAcquisitionsAggregationFrequency',
        'selectedAcquisitionsAggregationMode',
        'selectedAcquisitionsLowerbound',
        'selectedAcquisitionsUpperbound',
        
        'selectedConsumptionsDevices',
        'selectedConsumptionsParameters',
        'selectedConsumptionsAggregationFrequency',
        'selectedConsumptionsAggregationMode',
        'selectedConsumptionsLowerbound',
        'selectedConsumptionsUpperbound',
      ]),
      
      keyword() {
        return this.getFirstLetterUppercase(this.page);
      },

      aggregationModeLabel() {
        if(this.page == 'consumptions') return 'Modalità aggregazione';
        
        if(this['selected' + this.keyword + 'AggregationFrequency'] != undefined && this['selected' + this.keyword + 'AggregationFrequency'] != null)
          return 'Modalità aggregazione';
        else
          return 'Modalità aggregazione (opzionale)';
      }
    },

    watch: {
      selectedAcquisitionsDevices() {
        this.parameters = [];
        this.locked.parameters = true;

        if(this['selected' + this.keyword + 'Devices']['multidevice'] || (this['selected' + this.keyword + 'Devices'] != null && this['selected' + this.keyword + 'Devices']['device'])) {            
            this.getClientDeviceParameters();
        }
      },

      selectedAcquisitionsParameters() {
        this.fields.parametersAttributes['value']['value'] = this['selected' + this.keyword + 'Parameters'];
      },
      
      selectedConsumptionsDevices() {
        // this.parameters = [];
        // this.locked.parameters = true;
        if(this['selected' + this.keyword + 'Devices'] != null && this['selected' + this.keyword + 'Devices']['device']) {
            // this.getClientDeviceParameters();
        }
      },

      selectedConsumptionsParameters() {
        this.fields.parametersAttributes['value']['value'] = this['selected' + this.keyword + 'Parameters'];
      },

      selectedSite() {
        this.resetForm();
      }
    },

    methods: {
      getClientDeviceParameters() {
        this.overlay(true);

        this.$store
        .dispatch('getClientDeviceParameters', {page: this.page})
        .catch(error => {
            this.overlay(false);
            this.notify(this.$options.filters.notification({endpoint: 'GetClientDeviceParameters', code: error}));            
        })
        .then(({data}) => {
          this.overlay(false);

          /*
          if (error.response.data.mispErrorDTO.code != undefined)
          reject(error.response.data.mispErrorDTO.code);
          else
          reject(null);
          */
          this.notify(this.$options.filters.notification({endpoint: 'GetClientDeviceParameters', code: 200}));

          this.fields.parametersAttributes.options.value = data.parameters;
          this.parameters = data.parameters;

          this.locked.parameters = false;
        });          
      },

      getId(string) {
        var tmp = string.split("-");

        var response = '';
        for (let index = 0; index < tmp.length; index++) {
          response += this.getFirstLetterUppercase(tmp[index]);            
        }
        return response;
      },

      getFirstLetterUppercase(string) {
        return string.charAt(0).toUpperCase() + string.slice(1)
      },

      changed(changed) {
        var id = this.getId(changed.id);
        
        var value = null;
        
        if(changed.value != null && changed.value != '')
          value = changed.value;
        
        this.$store.dispatch('change' + id, value);
      },
      
      generateTSFileRequest() {
        var offset = new Date().getTimezoneOffset();

        var request = {
          clientId: this.clientId,
          sessionToken: this.token,
          deviceIds: [this['selected' + this.keyword + 'Devices']['device']['id']],
          paramIds: [this['selected' + this.keyword + 'Parameters']],
          fileFormat: 'CSV'
        };
          
        if(this.fields.lowerboundAttributes != undefined && this['selected' + this.keyword + 'Lowerbound'] != undefined) {
          if(this.fields.lowerboundAttributes.dateFormat.value == 'DD/MM/YYYY LT') {
            var lower = this['selected' + this.keyword + 'Lowerbound'].split(" ");
            request['aqDatetimeLowerbound'] = moment(this['selected' + this.keyword + 'Lowerbound'] + ' 00:00:00', 'DD/MM/YYYY HH:mm:ss').add(offset, 'minutes').format('YYYY-MM-DD') + 'T' + moment(lower[1], 'HH:mm').add(offset, 'minutes').format('HH:mm:ss') + 'Z';
          } else {
            request['aqDatetimeLowerbound'] = moment(this['selected' + this.keyword + 'Lowerbound'] + ' 00:00:00', 'DD/MM/YYYY HH:mm:ss').add(offset, 'minutes').format('YYYY-MM-DD') + 'T' + moment(this['selected' + this.keyword + 'Lowerbound'] + ' 00:00:00', 'DD/MM/YYYY HH:mm:ss').add(offset, 'minutes').format('HH:mm:ss') + 'Z';
          }
        }
          
        if(this.fields.upperboundAttributes != undefined && this['selected' + this.keyword + 'Upperbound'] != undefined) {
          if(this.fields.upperboundAttributes.dateFormat.value == 'DD/MM/YYYY LT') {
            var upper = this['selected' + this.keyword + 'Upperbound'].split(" ");
            request['aqDatetimeUpperbound'] = moment(this['selected' + this.keyword + 'Upperbound'] + ' 00:00:00', 'DD/MM/YYYY HH:mm:ss').add(offset, 'minutes').format('YYYY-MM-DD') + 'T' + moment(upper[1], 'HH:mm').add(offset, 'minutes').format('HH:mm:ss') + 'Z';
          } else {
            request['aqDatetimeUpperbound'] = moment(this['selected' + this.keyword + 'Upperbound'] + ' 23:59:59', 'DD/MM/YYYY HH:mm:ss').add(offset, 'minutes').format('YYYY-MM-DD') + 'T' + moment(this['selected' + this.keyword + 'Lowerbound'] + ' 23:59:59', 'DD/MM/YYYY HH:mm:ss').add(offset, 'minutes').format('HH:mm:ss') + 'Z';
          }
        }

        if(this['selected' + this.keyword + 'AggregationFrequency'] != undefined && this['selected' + this.keyword + 'AggregationFrequency'] != null) {
          if(request['aggregation'] == undefined)
            request['aggregation'] = {};
          request['aggregation']['frequency'] = this['selected' + this.keyword + 'AggregationFrequency'];
        }
        if(this['selected' + this.keyword + 'AggregationMode'] != undefined && this['selected' + this.keyword + 'AggregationMode'] != null) {
          if(request['aggregation'] == undefined)
            request['aggregation'] = {};

          request['aggregation']['mode'] = this['selected' + this.keyword + 'AggregationMode'];
        }

        return request;                          
      },

      generateTSFileRequestSite() {
        var offset = new Date().getTimezoneOffset();

        var request = {
          clientId: this.clientId,
          sessionToken: this.token,
          paramIds: [this['selected' + this.keyword + 'Parameters']],
          siteId: this.selectedSite,
          fileFormat: 'CSV'
        };
          
        if(this.fields.lowerboundAttributes != undefined && this['selected' + this.keyword + 'Lowerbound'] != undefined) {
          if(this.fields.lowerboundAttributes.dateFormat.value == 'DD/MM/YYYY LT') {
            var lower = this['selected' + this.keyword + 'Lowerbound'].split(" ");
            request['aqDatetimeLowerbound'] = moment(this['selected' + this.keyword + 'Lowerbound'] + ' 00:00:00', 'DD/MM/YYYY HH:mm:ss').add(offset, 'minutes').format('YYYY-MM-DD') + 'T' + moment(lower[1], 'HH:mm').add(offset, 'minutes').format('HH:mm:ss') + 'Z';
          } else {
            request['aqDatetimeLowerbound'] = moment(this['selected' + this.keyword + 'Lowerbound'] + ' 00:00:00', 'DD/MM/YYYY HH:mm:ss').add(offset, 'minutes').format('YYYY-MM-DD') + 'T' + moment(this['selected' + this.keyword + 'Lowerbound'] + ' 00:00:00', 'DD/MM/YYYY HH:mm:ss').add(offset, 'minutes').format('HH:mm:ss') + 'Z';
          }
        }
          
        if(this.fields.upperboundAttributes != undefined && this['selected' + this.keyword + 'Upperbound'] != undefined) {
          if(this.fields.upperboundAttributes.dateFormat.value == 'DD/MM/YYYY LT') {
            var upper = this['selected' + this.keyword + 'Upperbound'].split(" ");
            request['aqDatetimeUpperbound'] = moment(this['selected' + this.keyword + 'Upperbound'] + ' 00:00:00', 'DD/MM/YYYY HH:mm:ss').add(offset, 'minutes').format('YYYY-MM-DD') + 'T' + moment(upper[1], 'HH:mm').add(offset, 'minutes').format('HH:mm:ss') + 'Z';
          } else {
            request['aqDatetimeUpperbound'] = moment(this['selected' + this.keyword + 'Upperbound'] + ' 23:59:59', 'DD/MM/YYYY HH:mm:ss').add(offset, 'minutes').format('YYYY-MM-DD') + 'T' + moment(this['selected' + this.keyword + 'Lowerbound'] + ' 23:59:59', 'DD/MM/YYYY HH:mm:ss').add(offset, 'minutes').format('HH:mm:ss') + 'Z';
          }
        }

        if(this['selected' + this.keyword + 'AggregationFrequency'] != undefined && this['selected' + this.keyword + 'AggregationFrequency'] != null) {
          if(request['aggregation'] == undefined)
            request['aggregation'] = {};
          request['aggregation']['frequency'] = this['selected' + this.keyword + 'AggregationFrequency'];
        }
        if(this['selected' + this.keyword + 'AggregationMode'] != undefined && this['selected' + this.keyword + 'AggregationMode'] != null) {
          if(request['aggregation'] == undefined)
            request['aggregation'] = {};

          request['aggregation']['mode'] = this['selected' + this.keyword + 'AggregationMode'];
        }
        return request;                          
      },

      validateFilter() {
        if(this['selected' + this.keyword + 'Devices']['multidevice'] == undefined && (this['selected' + this.keyword + 'Devices'] == undefined || this['selected' + this.keyword + 'Devices']['device'] == undefined || this['selected' + this.keyword + 'Devices']['device']['id'] == undefined || this['selected' + this.keyword + 'Devices']['device']['id'] == '' || this['selected' + this.keyword + 'Devices']['device']['id'] == null)) {
          this.notify(this.$options.filters.notification({endpoint: 'ValidateFilter', code: 601}));
          return false;
        }

        if(this['selected' + this.keyword + 'Parameters'] == undefined || this['selected' + this.keyword + 'Parameters'] == '' || this['selected' + this.keyword + 'Parameters'] == null) {
          this.notify(this.$options.filters.notification({endpoint: 'ValidateFilter', code: 602}));
          return false;
        }

        if(this.page == 'consumptions') return 'Modalità aggregazione';
        
        if(this['selected' + this.keyword + 'AggregationFrequency'] != undefined && this['selected' + this.keyword + 'AggregationFrequency'] != null && (this['selected' + this.keyword + 'AggregationMode'] == undefined || this['selected' + this.keyword + 'AggregationMode'] == '' || this['selected' + this.keyword + 'AggregationMode'] == null)) {
          //Verifico sia stata inserita la frequenza di aggregazione e non la modalità di aggregazione
          this.notify(this.$options.filters.notification({endpoint: 'ValidateFilter', code: 605}));
          return false;          
        }
        
        if(this['selected' + this.keyword + 'Upperbound'] == undefined || this['selected' + this.keyword + 'Upperbound'] == '' || this['selected' + this.keyword + 'Upperbound'] == null) {
          this.notify(this.$options.filters.notification({endpoint: 'ValidateFilter', code: 603}));
          return false;
        }
        
        if(this['selected' + this.keyword + 'Lowerbound'] == undefined || this['selected' + this.keyword + 'Lowerbound'] == '' || this['selected' + this.keyword + 'Lowerbound'] == null) {
          this.notify(this.$options.filters.notification({endpoint: 'ValidateFilter', code: 604}));
          return false;
        }

        
        return true;
      },
      
      exportData() {
        if(!this.ready || !this.validateFilter())
          return;
              
        this.overlay(true);

        this.$store
        .dispatch('getTSFile', {request: this.generateTSFileRequest()})
        .catch(error => {
            this.overlay(false);

            this.notify(this.$options.filters.notification({endpoint: 'GetTSFile', code: error}));
        })
        .then(({data}) => {
          this.overlay(false);

          this.notify(this.$options.filters.notification({endpoint: 'GetTSFile', code: 200}));
          
          if(data['url'] != undefined) {
            var win = window.open(data['url'], '_blank');
            win.focus();
          }
        });            
          
      },

      exportDataSite() {
        if(!this.ready)
          return;
              
        this.overlay(true);

        this.$store
        .dispatch('getTSFile', {request: this.generateTSFileRequestSite()})
        .catch(error => {
            this.overlay(false);

            this.notify(this.$options.filters.notification({endpoint: 'GetTSFile', code: error}));
        })
        .then(({data}) => {
          this.overlay(false);

          this.notify(this.$options.filters.notification({endpoint: 'GetTSFile', code: 200}));
          if(data['url'] != undefined) {
            var win = window.open(data['url'], '_blank');
            win.focus();
          }
        });            
          
      },

      getData() {
        if(!this.ready || !this.validateFilter())
          return;

        //Emetto evento get ts data
        this.$emit('get-ts-data');
      },

      overlay(action) {
          this.loading = action;
      }, 
      
      resetForm() {
          this.reset = (((1+Math.random())*0x10000)|0).toString(16).substring(1);
      },
    }
  }
</script>